import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EuiTableSelectableRowService {

    public selectedRows$: BehaviorSubject<any[]> = new BehaviorSubject([]);
    public isAllRowsSelected$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private rows: any[] = [];
    private isAllRowsSelected = false;

    constructor() {}

    public addSelectedRow(row: any): void {
        this.selectedRows$.next([...this.selectedRows$.value, row]);
        if (this.selectedRows$.value.length === this.rows.length) {
            this.isAllRowsSelected$.next(true);
            this.isAllRowsSelected = true;
        } else {
            this.isAllRowsSelected$.next(false);
            this.isAllRowsSelected = false;
        }
    }

    public removeSelectedRow(row: any): void {
        const value = this.selectedRows$.value.filter(selected => selected.id !== row.id);
        this.selectedRows$.next(value);
        this.isAllRowsSelected$.next(false);
        this.isAllRowsSelected = false;
    }

    public addRow(row: any): void {
        if (this.rows.indexOf(row) === -1) {
            this.rows.push(row);

            if (this.rows.length > this.selectedRows$.value.length && this.isAllRowsSelected) {
                this.isAllRowsSelected$.next(false);
                this.isAllRowsSelected = false;
            }
        }
    }

    public selectRows(rows: any[]) {
        this.selectedRows$.next([...rows]);
        this.isAllRowsSelected$.next(false);
        this.isAllRowsSelected = false;
    }

    public selectAllRows(): void {
        this.selectedRows$.next([...this.rows]);
        this.isAllRowsSelected$.next(true);
        this.isAllRowsSelected = true;
    }

    public unselectAllRows(): void {
        this.selectedRows$.next([]);
        this.isAllRowsSelected$.next(false);
        this.isAllRowsSelected = false;
    }

}
